import { IonText } from '@ionic/react';
import React from 'react';

import analyticsStepImage from '@/assets/images/screens/analytics.png';
import shareStepImage from '@/assets/images/screens/booking.png';
import notificationsStepImage from '@/assets/images/screens/notifications.png';
import remindersStepImage from '@/assets/images/screens/reminder.png';
import approveStepImage from '@/assets/images/screens/requests.png';
import { Anchor, SectionHeader, Spacer } from '@/components/common';
import Step from '@/components/landingPage/howItWorks/step/Step';
import {
  checkmarkCircleOutline,
  linkOutline,
  mailUnreadOutline,
  notificationsOutline,
  trendingUpOutline
} from 'ionicons/icons';

import './HowItWorks.css';

interface HowItWorksProps {
  showHeader?: boolean;
  header?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({
  showHeader = true,
  header = 'How It Works'
}) => {
  const steps = [
    {
      id: 1,
      icon: linkOutline,
      title: (
        <>
          Share your <IonText color="primary">booking</IonText> link
        </>
      ),
      description: 'Patients book directly from your available schedule.',
      image: shareStepImage
    },
    {
      id: 2,
      icon: notificationsOutline,
      title: (
        <>
          Get <IonText color="primary">notifications</IonText> about requests
        </>
      ),
      description:
        'You will be notified when a patient requests an appointment.',
      image: notificationsStepImage
    },
    {
      id: 3,
      icon: checkmarkCircleOutline,
      title: (
        <>
          Approve <IonText color="primary">appointment</IonText> requests
        </>
      ),
      description:
        'You can approve or decline appointment requests in one click.',
      image: approveStepImage
    },
    {
      id: 4,
      icon: mailUnreadOutline,
      title: (
        <>
          Receive <IonText color="primary">automatic</IonText> reminders
        </>
      ),
      description:
        "We'll remind you and your patients before each appointment.",
      image: remindersStepImage
    },
    {
      id: 5,
      icon: trendingUpOutline,
      title: (
        <>
          Track and <IonText color="primary">improve</IonText> performance
        </>
      ),
      description:
        'Monitor your clinic with weekly analytics and performance insights.',
      image: analyticsStepImage
    }
  ];

  return (
    <div className="how-it-works">
      <Anchor id="to-how-it-works" />
      {showHeader && <SectionHeader>{header}</SectionHeader>}
      <Spacer top={16} />
      <div className="how-it-works__steps">
        {steps.map((step) => (
          <Step key={step.id} step={step} />
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
